export * from './loader.service';
export * from './loader.component';

export interface LoaderState {
    show: boolean;
}



// WEBPACK FOOTER //
// ./src/app/core/loader/loader.ts